// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// get the radio modulation entity by the radioModulationId,
// this was stored at segment end radio modulation.
// if there's no match, return an empty object
const getRadioModulation = (modulations, radioModulationId) => (
  modulations.find(d => d.radioModulationId === radioModulationId) || {}
)

export default getRadioModulation
